import { Injectable } from '@angular/core';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { ProductListItem } from '../../resources/product-list-item.model';
import { ROW_DELETED_CLASS } from '@gh/common-internal-shared';

@Injectable()
export class ProductListGridDefinition extends LayoutBasedGridDefinition {
  private static readonly ACTIVE_STATUSES = new Set(['active']);
  private static readonly ARCHIVED_STATUSES = new Set(['archive', 'archived', 'deactivated']);

  options = {
    getRowId: (params) => String(params.data.id),
    rowClassRules: {
      [ROW_DELETED_CLASS]: ({ data }: { data: ProductListItem }) => data.active === false,
    },
  };

  layoutName = 'product-list'; // This should match your grid layout config if you have one

  buildColumnDefs() {
    const statusClassResolver = ({ value, data }: { value?: string; data?: ProductListItem }) => {
      const normalizedStatus = String(value ?? '').trim().toLowerCase();

      if (ProductListGridDefinition.ACTIVE_STATUSES.has(normalizedStatus) || data?.active === true) {
        return 'active-status';
      }

      if (ProductListGridDefinition.ARCHIVED_STATUSES.has(normalizedStatus) || data?.active === false) {
        return 'deleted-status';
      }

      return undefined;
    };

    return {
      name: { headerName: 'Plan Name', field: 'name' },
      fee: { 
        headerName: 'Monthly Price(ex GST)', 
        field: 'fee',
        valueFormatter: ({ value }: { value: number }) => {
          if (value == null) { 
            return ''; 
          }
          return Number(value).toFixed(2);
        },
      },
      status: {
        headerName: 'Status',
        field: 'status',
        cellClass: statusClassResolver,
      },
    };
  }
}

